import styles from './ProgramDetails.module.css';
import { FaCalendarAlt, FaClock, FaUserGraduate, FaLaptop, 
         FaBookOpen, FaChalkboardTeacher, FaCertificate } from 'react-icons/fa';

const ProgramDetails = () => {
  const details = [
    {
      title: "Nos of sessions & fees",
      icon: FaCalendarAlt,
      content: {
        subtitle: "(For grade 1-12)",
        items: [
          {
            duration: "3 months",
            sessions: "12 sessions",
            price: "999",
          },
          {
            duration: "6 months",
            sessions: "24 sessions",
            price: "999",
          },
          {
            duration: "9 months",
            sessions: "36 sessions",
            price: "999",
          }
        ]
      }
    },
    {
      title: "Each session duration",
      icon: FaClock,
      content: {
        text: "60 Minutes / Session"
      }
    },
    {
      title: "Class mode",
      icon: FaUserGraduate,
      content: {
        text: "1 Teacher : 1 Student"
      }
    },
    {
      title: "Requirements for student",
      icon: FaLaptop,
      content: {
        text: "Computer & strong internet"
      }
    },
    {
      title: "Curriculum",
      icon: FaBookOpen,
      content: {
        text: "Proven curriculum & STEM certified trainers"
      }
    },
    {
      title: "Mentor",
      icon: FaChalkboardTeacher,
      content: {
        text: "Highly qualified STEM Engineers take classes"
      }
    },
    {
      title: "Certification",
      icon: FaCertificate,
      content: {
        text: "Internationally approved STEM.org E-Certification"
      }
    }
  ];

  return (
    <section className={styles.programDetails}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <span className={styles.titleText}>Program Details</span>
          <span className={styles.titleLine}></span>
        </h2>
        
        <div className={styles.detailsGrid}>
          {details.map((detail, index) => (
            <div key={index} className={`${styles.detailCard} ${index === 0 ? styles.pricingCard : ''}`}>
              <div className={styles.cardHeader}>
                <detail.icon className={styles.icon} />
                <h3>{detail.title}</h3>
              </div>
              <div className={styles.content}>
                {detail.content.subtitle && (
                  <p className={styles.subtitle}>{detail.content.subtitle}</p>
                )}
                {detail.content.items ? (
                  detail.content.items[0].duration ? (
                    <div className={styles.pricingGrid}>
                      {detail.content.items.map((item, idx) => (
                        <div key={idx} className={styles.pricingItem}>
                          <div className={styles.duration}>{item.duration}</div>
                          <div className={styles.sessions}>{item.sessions}</div>
                          <div className={styles.price}>
                            <span className={styles.currency}>₹</span>
                            <span className={styles.amount}>{item.price}</span>
                            <span className={styles.perSession}>/ session</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <ul className={styles.list}>
                      {detail.content.items.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  )
                ) : (
                  <p className={styles.text}>{detail.content.text}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramDetails; 